import type { Theme } from "@mui/material/styles";
import type { AppCommonStyles } from "../types";

export function buildCommonStyles(_theme: Theme): AppCommonStyles {
  return {
    flexRowGapHalf: {
      display: "flex",
      gap: 0.5,
    },
    flexRowGapOne: {
      display: "flex",
      gap: 1,
    },
    marginRightOne: {
      mr: 1,
    },
    marginBottomTwo: {
      mb: 2,
    },
    marginTopTwo: {
      mt: 2,
    },
    fullWidth: {
      width: 1,
    },
    deleteOutlinedButton: {
      color: "error.main",
      borderColor: "error.main",
      "&:hover": {
        borderColor: "error.dark",
        bgcolor: "error.main",
        color: "error.contrastText",
      },
    },
    tabsMarginBottomTwo: {
      mb: 2,
      width: "fit-content",
      maxWidth: "100%",
    },
    drawerBackdrop: {
      bgcolor: "rgba(0,0,0,0.35)",
    },
  };
}
